import { Photo } from 'react-bytesize-icons';
import refimg from "../../../../assets/images/docs/referenceimage.mp4";
import imageslider from "../../../../assets/images/docs/referenceimage/image-slider.mp4";
import * as React from 'react';
export default {
  Photo,
  refimg,
  imageslider,
  React
};